module.exports = __webpack_public_path__ + "d20d5f351b1b80d36f01abaf690e794c.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/treasury.png
// module id = 120
// module chunks = 0